import React from 'react';

import appConfig from '../../config/appConfig';
import * as localizationKeys from '../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../services/localization/localizationService';
import LeviaLearnMoreItem from '../Levia/LeviaLearnMore/LeviaLearnMoreItem';

const FirmwareReleaseNotesChanges = (props) => {
    const {titleKey = localizationKeys.FIRMWARE_MODAL_VIEW_FWU_CHANGES_124_4_4_FEATURES_LIST_TITLE} = props;
    const iconsList = appConfig.getFirmwareReleaseNotesChangesIcons();

    const changesList = [
        {
            iconPath: iconsList?.[0],
            titleKey: localizationKeys.FIRMWARE_MODAL_VIEW_FWU_CHANGES_124_4_4_ITEM_1,
        },
        {
            iconPath: iconsList?.[1],
            titleKey: localizationKeys.FIRMWARE_MODAL_VIEW_FWU_CHANGES_124_4_4_ITEM_2,
        },
    ];

    const localizedStrings = getLocalizedStrings();

    return (
        <>
            <p className='mt-6 text-20 font-bold'>{localizedStrings[titleKey]}</p>
            <ul className='mx-auto mt-6 flex max-w-[312px] flex-col items-center gap-4 md:mt-4'>
                {changesList.map((item, index) => (
                    <LeviaLearnMoreItem key={index} item={item} />
                ))}
            </ul>
        </>
    );
};

export default FirmwareReleaseNotesChanges;
